import { appLogs } from "./firebase";

export async function appLogsWrapper({ type = 'info', module = '', data = '', description = '', errorDetails = null, createdBy = '-' }) {
  try {
    await appLogs.add({
      type,
      module,
      data,
      description,
      errorDetails: errorDetails ? JSON.parse(JSON.stringify(errorDetails)) : null,
      createdBy,
      createdAt: new Date().toISOString()
    });
  } catch (logError) {
    console.error("Failed to log to AppLogs:", logError);
  }
}
